import { KeyRound, LockKeyhole, Pickaxe } from "lucide-react";
import { Meter } from "../ui/Resources";

export function ChestEncounter({
  keys,
  cost,
  onChoice,
  busy,
}: {
  keys: number;
  cost: number;
  onChoice: (open: boolean) => void;
  busy: boolean;
}) {
  return (
    <div className="chest-encounter">
      <div className="chest-pixel">
        <LockKeyhole size={48} />
      </div>
      <h2>岩壁宝箱</h2>
      <p>金币与恢复 12% 最大生命的绷带</p>
      <div className="chest-actions">
        <button
          className="primary-command compact"
          disabled={busy || keys < cost}
          onClick={() => onChoice(true)}
        >
          <KeyRound size={18} />
          开启 · {cost}
        </button>
        <button className="secondary-command" disabled={busy} onClick={() => onChoice(false)}>
          跳过
        </button>
      </div>
    </div>
  );
}

export function ObstacleEncounter({
  progress,
  target,
  attempts,
  maxAttempts,
}: {
  progress: number;
  target: number;
  attempts: number;
  maxAttempts: number;
}) {
  const percent = target > 0 ? Math.min(100, (progress / target) * 100) : 0;
  return (
    <div className="chest-encounter obstacle-encounter">
      <div className="chest-pixel">
        <Pickaxe size={48} />
      </div>
      <h2>岩壁障碍</h2>
      <p>用剑方块积累破坏力，限定尝试内清除</p>
      <Meter value={percent} tone="enemy" />
      <div className="obstacle-readout">
        <strong>
          {progress} / {target}
        </strong>
        <span>
          尝试 {attempts} / {maxAttempts}
        </span>
      </div>
    </div>
  );
}
